import { render, staticRenderFns } from "./DocumentationPage.vue?vue&type=template&id=e661a82c&"
import script from "./DocumentationPage.vue?vue&type=script&lang=ts&"
export * from "./DocumentationPage.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentationPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports